/** Access roles, lowest to highest authority. */
export type Role = "viewer" | "author" | "admin";

export const ROLES: Role[] = ["viewer", "author", "admin"];

const RANK: Record<Role, number> = { viewer: 0, author: 1, admin: 2 };

export function isRole(x: unknown): x is Role {
  return typeof x === "string" && x in RANK;
}

/** True when `role` is at least as privileged as `min`. */
export function hasAtLeast(role: Role, min: Role): boolean {
  return RANK[role] >= RANK[min];
}

/** Can create/edit content packs. */
export function canAuthor(role: Role): boolean {
  return hasAtLeast(role, "author");
}

/** Can publish a pack to shared storage. */
export function canPublish(role: Role): boolean {
  return hasAtLeast(role, "author");
}

/** Can manage users and change roles (the admin gate). */
export function canManageUsers(role: Role): boolean {
  return hasAtLeast(role, "admin");
}
